export default "__VITE_ASSET__DsQT1OA7__"